import { deviceApi } from "../../api/deviceApi"
import { accessToken } from "../../hooks/useAccessToken"
import { deviceListSignal, deviceListLoadingSignal, deviceListErrorSignal, deviceFormsSignal, deviceFormsLoadingSignal, deviceFormsErrorSignal } from "../signals/deviceSignals"

export async function fetchDeviceList(businessEntityId, filter, config, accessToken) {
   deviceListLoadingSignal.value = true
   deviceListErrorSignal.value = null

    try {
        const result = await deviceApi.fetchDeviceList(businessEntityId, filter, config, accessToken)
        deviceListSignal.value = result.deviceView
    }
    catch (err) {
        deviceListErrorSignal.value = err.message
    }
    finally {
        deviceListLoadingSignal.value = false
    }
}

export async function fetchDeviceForms(businessEntityId, config, accessToken) {
   deviceFormsLoadingSignal.value = true
   deviceFormsErrorSignal.value = null

    try {
        const result = await deviceApi.fetchDeviceForms(businessEntityId, config, accessToken)
        deviceFormsSignal.value = result.componentDeviceForm
    }
    catch (err) {
        deviceFormsErrorSignal.value = err.message
    }
    finally {
        deviceFormsLoadingSignal.value = false
    }
}